import { BootScreen } from '@/atoms/BootScreen'
import { useAuthBootstrap } from '@/hooks/useAuth'
import { useAppRoute } from '@/hooks/useAppRoute'
import { AgenciesPage, AgencyDetailPage } from '@/modules/agencies'
import { LoginPage } from '@/pages/LoginPage'
import { AgencyShell } from '@/templates/AgencyShell'

export function App() {
  const { status } = useAuthBootstrap()
  const { isLoginRoute, isAgencyDetailRoute } = useAppRoute()

  if (status === 'unknown') {
    return <BootScreen />
  }

  if (status === 'unauthenticated' || isLoginRoute) {
    return <LoginPage />
  }

  return (
    <AgencyShell>
      {isAgencyDetailRoute ? <AgencyDetailPage /> : <AgenciesPage />}
    </AgencyShell>
  )
}
